import { ContextItemType, ContextItems } from 'src/@types/ai';

export const useAIContextActionsUtils = () => {
  const getLabel = (item: ContextItems) => {
    if (item.type === ContextItemType.DOC) {
      return item.doc?.title;
    }

    if (
      item.type === ContextItemType.IMAGE ||
      item.type === ContextItemType.FILE
    ) {
      return item[item.type]?.media.name;
    }

    if (item.type === ContextItemType.DRIVE) {
      return item[item.type]?.name;
    }

    return item[item.type]?.title;
  };

  return {
    getLabel,
  };
};
